var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "footer-section"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "footer-row"
  }, [_vm._m(0), _c('footer-contact-column'), _c('footer-link-column'), _c('footer-link-column2', {
    on: {
      "openPopup": _vm.openPopup
    }
  }), _c('footer-contact-column2')], 1), _c('div', {
    staticClass: "footer-row"
  }, [_c('div', {
    staticClass: "copyright caption"
  }, [_vm._v(_vm._s(_vm.$t('footer.copyright')))]), _vm._m(1), _c('div', {
    staticClass: "link-container overline"
  }, [_c('div', {
    staticClass: "nav-link",
    on: {
      "click": function ($event) {
        return _vm.openPopup('IMPRESSUM');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.imprint')))]), _c('div', {
    staticClass: "nav-link",
    on: {
      "click": function ($event) {
        return _vm.openPopup('TERMS');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.terms')))])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "footer-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo/seu-logo.svg"),
      "alt": ""
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "arrow-container"
  }, [_c('div', {
    staticClass: "line"
  }), _c('img', {
    staticClass: "arrowhead",
    attrs: {
      "src": require("../../assets/icons/arrow-right-divider.svg"),
      "alt": ""
    }
  })]);

}]

export { render, staticRenderFns }